function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "circle",
  d: "M36 19.561C36 28.1949 28.7171 36 20 36C10.447 36 4 28.2629 4 19.561C4 11.0533 11.1577 4 20 4C28.8423 4 36 11.0533 36 19.561Z",
  stroke: "black",
  strokeWidth: 4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "info",
  d: "M22.4609 31H17.5098V15.1504H22.4609V31ZM17.2168 11.0635C17.2168 10.3604 17.4707 9.78418 17.9785 9.33496C18.4863 8.88574 19.1455 8.66113 19.9561 8.66113C20.7666 8.66113 21.4258 8.88574 21.9336 9.33496C22.4414 9.78418 22.6953 10.3604 22.6953 11.0635C22.6953 11.7666 22.4414 12.3428 21.9336 12.792C21.4258 13.2412 20.7666 13.4658 19.9561 13.4658C19.1455 13.4658 18.4863 13.2412 17.9785 12.792C17.4707 12.3428 17.2168 11.7666 17.2168 11.0635Z",
  fill: "black"
});

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ce83bd6c.svg";
export { ForwardRef as ReactComponent };